import React from 'react';

import AnalyticsWrapper from './Blocks/AnalyticsWrapper';
import type { WithAnalyticsWrapperProps } from './interfaces';

const WithAnalyticsWrapper = ({ config, children }: WithAnalyticsWrapperProps) => (
  <AnalyticsWrapper
    shouldTrackClick={config?.click_tracking as boolean}
    shouldTrackImpression={config?.impression_tracking as boolean}
    trackingLocation={config?.analytics_location as string}
  >
    {children}
  </AnalyticsWrapper>
);

export default WithAnalyticsWrapper;
